<template>
  <UAvatar
    :alt="teams.selected?.name.toUpperCase()"
    size="xs"
  />
  <div class="flex flex-col gap-1 justify-start">
    <h3>
      {{ teams.selected?.name }}
    </h3>
    <p
      v-if="teams.selected"
      class="text-xs text-left text-muted"
    >
      {{ format(teams.selected.balance) }}
    </p>
  </div>
</template>

<script setup lang="ts">
const { format } = useCost()
const teams = useTeamsStore()
</script>
